module.exports = __webpack_public_path__ + "img/pr-4.e8246d10.png";